import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { KeyValuePair } from 'allai-admin-shared';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from '../../../../services/users/user.service.js';

/** The organization detail page */
@Component({
	selector: 'app-user-detail',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		MatTableModule
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './user-detail.component.html',
	styleUrl: './user-detail.component.scss'
})

export class UserDetailComponent implements OnInit, OnDestroy {

	userDataSource: MatTableDataSource<KeyValuePair>;
	readonly displayedColumns: (keyof KeyValuePair)[] = ['key', 'value'];

	constructor(private usersService: UsersService, private router: Router, private route: ActivatedRoute) {

	}

	ngOnInit() {
		this.usersService.onNewUserDetail.subscribe(() => {
			this.refresh();
		});

		this.usersService.resolveUserDetail(this.route.snapshot.params["id"]);
	}
	private refresh() {

		let userDetail = this.usersService.userDetail;
		let data: KeyValuePair[] = [];
		if (userDetail) {
			data = [
				{ key: "Id", value: userDetail.user.id },
				{ key: "Name", value: `${userDetail.user.first_name} ${userDetail.user.last_name}` },
				{ key: "Email", value: userDetail.user.email },
				{ key: "Organization", value: `${userDetail.organization.id} - ${userDetail.organization.name}`, link: { path: "organization", id: userDetail.organization.id } },
				{ key: "Type", value: userDetail.user.user_type },
				{ key: "Enabled", value: `${userDetail.user.enabled}` },
				{ key: "Signature", value: userDetail.user.signature },
				{ key: "Appointment Description", value: userDetail.user.appointment_description },
			]
		}
		this.userDataSource = new MatTableDataSource<KeyValuePair>(data);
	}

	ngOnDestroy() {
	}

	gotoRow(row: KeyValuePair) {
		if (row.link) {
			let url = this.router.serializeUrl(this.router.createUrlTree(['/', row.link.path, row.link.id]));
			window.open(url, `_${row.link.path}_${row.link.id}`);

		}
	}
}
